import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { setViewportWidthVariable } from './modules/set-viewport-width-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { overlay } from './modules/overlay.js';
import { tabs } from './modules/tabs.js';
import { accordion } from './modules/accordion.js';
import { contactForm7Redirect } from './modules/contact-form-7-redirect.js';
import { contactForm7Flatpickr } from './modules/contact-form-7-flatpickr.js';
import { initializePageLoaded } from './modules/page-loaded.js';
import { initCaseSwiper } from './modules/case-swiper.js';
import { initVoiceSwiper } from './modules/voice-swiper.js';
import { initPhotoStudioSwiper } from './modules/photo-studio-swiper.js';
import { initLineUpSwiper } from './modules/line-up-swiper.js';
import { headerScrollActive } from './modules/header-scroll-active.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
const init = () => {
  initializePageLoaded();
  setHeaderHeightVariable();
  setViewportWidthVariable();
  delayedScroll();
  disableTelOnPC();
  overlay();
  tabs();
  accordion();
  contactForm7Redirect();
  contactForm7Flatpickr();
  initCaseSwiper();
  initVoiceSwiper();
  initPhotoStudioSwiper();
  initLineUpSwiper();
  headerScrollActive();
};

// スクリプトが DOMContentLoaded 後に読み込まれても必ず実行されるようにする
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
